import __request__ from "routing/request";
export function exportData(JSONbody, filename) {
  return __request__("POST", `/views/search/pivot/export/${filename}`, JSONbody, {}, {
    "Accept": [
      "text/csv",
      "application/json",
      "application/yaml",
      "application/xml",
      "application/vnd.ms-excel"
    ]
  });
}
